class StockistContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const allGenderButtons = document.querySelectorAll('button[data-gender]');

    if (allGenderButtons.length === 0) return;

    const allGenderContent = document.querySelectorAll('address[data-gender]');

    allGenderButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const gender = this.getAttribute('data-gender');

        allGenderButtons.forEach((content) => {
          content.classList.add('text-gray-600');
          content.classList.remove('text-gray-800');
        });
        this.classList.remove('text-gray-600');
        this.classList.add('text-gray-800');

        allGenderContent.forEach((element) => {
          if (element.getAttribute('data-gender') === gender || element.getAttribute('data-gender') === 'both') {
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
        });
      });
    });
  }

  disconnectCallback() {
    this.allGenderButtons.forEach((button) => {
      button.removeEventListener('click', this.buttonClickHandler);
    });
  }
}

customElements.define('stockist-content', StockistContent);
